<div class="sp-width__full sp-grid__summary-6 sp-grid__gap sp-overflow__x-scroll">
  <app-shared-summary-item
    [item_label]="'COMPANIES.SUMMARY_NO_CONTRACT_LABEL'"
    [item_value]="summary?.pending_evaluation?.toString() || '0'"
    [item_class]="'sp-background__status-400'"
    [label_class]="'sp-color__primary'"
    [value_class]="'sp-color__primary'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'COMPANIES.SUMMARY_PENDING_SIGNATURE_LABEL'"
    [item_value]="summary?.pending_signature?.toString() || '0'"
    [item_class]="'sp-background__status-100'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'COMPANIES.SUMMARY_PENDING_EVALUATION_LABEL'"
    [item_value]="summary?.pending_acceptance?.toString() || '0'"
    [item_class]="'sp-background__status-200'"
    [label_class]="'sp-color__primary'"
    [value_class]="'sp-color__primary'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'COMPANIES.SUMMARY_ACCEPTED_LABEL'"
    [item_value]="summary?.accepted?.toString() || '0'"
    [item_class]="'sp-background__status-50'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'COMPANIES.SUMMARY_DENIED_LABEL'"
    [item_value]="summary?.denied?.toString() || '0'"
    [item_class]="'sp-background__status-300'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'COMPANIES.SUMMARY_ARCHIVED_LABEL'"
    [item_value]="summary?.archived?.toString() || '0'"
    [item_class]="'sp-orders__status-archived'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
</div>
